import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import ArrowExpandRight from './arrowExpandRight.svg';

type IconButtonProps = {
  size?: SizeType,
  iconSize?: number,
  onClick?: () => void,
};

export const ArrowExpandRightIcon = (props: any) => <Icon component={ArrowExpandRight} {...props} />;

export const ArrowExpandRightButton = ({ size = 'medium', iconSize = 24, ...props }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<ArrowExpandRightIcon width={iconSize} height={iconSize} />}
    size={size}
    {...props}
  />
);
